import { T0 } from '../data';
import { reducedMotion } from './motion';

/**
 * The sample-data clock: 25 Sep 2026 10:00 BST at page load, then real time.
 * The server renders the samples at T0, so the first tick continues where
 * the HTML left off. The landing page's sample alerts and /get-started's
 * preview read it; the live raises' cards tick on Date.now() (liveFeed in
 * widgets.ts).
 */
const START = Date.now();

export function now(): number {
  return T0 + (Date.now() - START);
}

type Tick = (now: number) => void;

const listeners = new Set<Tick>();
let timer: number | undefined;

// One timer for every countdown on the page, on the clock's second boundary.
// Under reduced motion it ticks once a minute, as the dashboard's does
// (design-tokens.md, Motion).
const PERIOD = reducedMotion() ? 60_000 : 1_000;

function run() {
  const n = now();
  listeners.forEach((l) => l(n));
}

function schedule() {
  const wait = PERIOD - ((Date.now() - START) % PERIOD);
  timer = window.setTimeout(() => {
    run();
    schedule();
  }, wait);
}

/** Calls `listener` every tick; the function it returns stops that. */
export function onTick(listener: Tick): () => void {
  listeners.add(listener);
  if (timer === undefined) schedule();
  return () => {
    listeners.delete(listener);
    if (listeners.size > 0 || timer === undefined) return;
    window.clearTimeout(timer);
    timer = undefined;
  };
}

// Background tabs throttle timers; catch up the moment the tab is back.
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) run();
});
